/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DimensionValuesRequest { 
    displayAttribute?: string;
    filterAttribute?: string;
    filterByAcronym?: boolean;
    filterByName?: boolean;
    page?: number;
    searchTerm?: string;
    selectionMode?: DimensionValuesRequest.SelectionModeEnum;
    size?: number;
    sortDirection?: DimensionValuesRequest.SortDirectionEnum;
    subsetId?: string;
    valueFilter?: Array<string>;
}
export namespace DimensionValuesRequest {
    export type SelectionModeEnum = 'ALL' | 'INCLUDE' | 'EXCLUDE';
    export const SelectionModeEnum = {
        All: 'ALL' as SelectionModeEnum,
        Include: 'INCLUDE' as SelectionModeEnum,
        Exclude: 'EXCLUDE' as SelectionModeEnum
    };
    export type SortDirectionEnum = 'DESC' | 'ASC' | 'DESC_INDEX' | 'ASC_INDEX' | 'SOURCE_ORDER';
    export const SortDirectionEnum = {
        Desc: 'DESC' as SortDirectionEnum,
        Asc: 'ASC' as SortDirectionEnum,
        DescIndex: 'DESC_INDEX' as SortDirectionEnum,
        AscIndex: 'ASC_INDEX' as SortDirectionEnum,
        SourceOrder: 'SOURCE_ORDER' as SortDirectionEnum
    };
}


